export const appName = 'trackIT'
export const appDescription = 'Das Zeiterfassungstool'
export const appRobots = 'noindex, nofollow'

export const unknownError = 'Da hat etwas nicht funktioniert!'

export const euroNumberFormat = Intl.NumberFormat('de', { style: 'currency', currency: 'EUR' })

export const copyFeatureNotSupportedHint = 'Dein Browser unterstützt den Zugriff auf die Zwischenablage nicht! Bitte überprüfe Kompatibilität und Berechtigung.'
